import './styles.css'
import React, { useState, useRef } from 'react'

/* ---- INSERIR AQUI (após as imports) ---- */
const normalizeKey = s =>
  String(s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // remove acentos/diacríticos
    .toLowerCase()
function OneCardCarousel({ items = [], renderItem }) {
  const [index, setIndex] = useState(0);
  const total = items.length;
  const viewportRef = useRef(null);
  const trackRef = useRef(null);
  const startX = useRef(null);
  const isDragging = useRef(false);
  const [slideWidth, setSlideWidth] = useState(0);

  // calcula a largura visível (em px) do "viewport" do carrossel
  const measure = () => {
    const vp = viewportRef.current;
    if (!vp) return;
    // clientWidth é width interior (exclui scrollbars)
    setSlideWidth(vp.clientWidth);
  };

  React.useEffect(() => {
    measure();
    // atualizar no resize
    const onResize = () => measure();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // quando items mudam, garante index válido
  React.useEffect(() => {
    if (index >= total) setIndex(0);
    // re-measure (em caso de conteúdo diferente)
    measure();
  }, [total]); // eslint-disable-line

  const clamp = (i) => (total ? ((i % total) + total) % total : 0);

  const prev = () => { if (total > 1) setIndex(i => clamp(i - 1)); };
  const next = () => { if (total > 1) setIndex(i => clamp(i + 1)); };

  // swipe handling (pointer-friendly)
  const onPointerDown = (e) => {
    const clientX = e.touches?.[0]?.clientX ?? e.clientX;
    startX.current = clientX;
    isDragging.current = true;
  };
  const onPointerUp = (e) => {
    if (!isDragging.current) return;
    const clientX = e.changedTouches?.[0]?.clientX ?? e.clientX;
    const dx = clientX - (startX.current ?? clientX);
    if (dx > 40) prev();
    if (dx < -40) next();
    isDragging.current = false;
    startX.current = null;
  };

  const onKeyDown = (e) => {
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  };

  // transform em pixels — usa slideWidth medido
  const trackStyle = {
    transform: `translateX(-${index * (slideWidth || 0)}px)`,
    transition: 'transform 380ms cubic-bezier(.22,.9,.3,1)',
    // garante que o track tenha largura suficiente (opcional)
    width: (slideWidth && total) ? `${slideWidth * total}px` : 'auto',
  };

  return (
    <div className="oc-carousel">
      <button
        className="oc-btn"
        onClick={prev}
        aria-label="Anterior"
        disabled={total <= 1}
      >
        ‹
      </button>

      <div
        className="oc-viewport"
        ref={viewportRef}
        onTouchStart={onPointerDown}
        onTouchEnd={onPointerUp}
        onMouseDown={onPointerDown}
        onMouseUp={onPointerUp}
        onKeyDown={onKeyDown}
        tabIndex={0}
        aria-roledescription="carousel"
        aria-label="Planos"
      >
        <div
          className="oc-track"
          ref={trackRef}
          style={trackStyle}
        >
          {total === 0 ? (
            <div className="oc-slide">
              <div className="Styled-item">
                <p className="Number">—</p>
                <p className="Number-info">Nenhum plano</p>
              </div>
            </div>
          ) : items.map((item, i) => (
            <div
              key={item.id ?? i}
              className="oc-slide"
              aria-roledescription="slide"
              aria-label={`Slide ${i + 1} de ${total}`}
              style={{ width: slideWidth ? `${slideWidth}px` : '100%' }}
            >
              {renderItem(item)}
            </div>
          ))}
        </div>
      </div>

      <button
        className="oc-btn"
        onClick={next}
        aria-label="Próximo"
        disabled={total <= 1}
      >
        ›
      </button>
    </div>
  );
}

export default function Planos({
  number,
  numberInfo,
  infoUp,
  infoBottom,
  price
}) {
  const [location, setLocation] = useState('Manaus') // Change the location here

  const handleLocationChange = newLocation => {
    setLocation(newLocation)
  }

  const manausPlanes = [
    {
      id: 1,
      number: 100,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 99,99'
    },
    {
      id: 2,
      number: 200,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 129,99'
    },
    {
      id: 3,
      number: 300,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 139,99'
    },
    {
      id: 4,
      number: 500,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',

      price: 'R$ 159,99'
    },
    {
      id: 5,
      number: 300,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 119,99'
    },
    {
      id: 6,
      number: 300,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 249,99'
    },
    {
      id: 7,
      number: 400,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 129,99'
    },
    {
      id: 8,
      number: 400,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 259,99'
    },
    {
      id: 9,
      number: 500,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 139,99'
    },
    {
      id: 10,
      number: 500,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 269,99'
    },
    {
      id: 11,
      number: 300,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 139,99'
    },
    {
      id: 12,
      number: 300,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 269,99'
    },
    {
      id: 13,
      number: 400,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 149,99'
    },
    {
      id: 14,
      number: 400,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 279,99'
    },
    {
      id: 15,
      number: 500,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 159,99'
    },
    {
      id: 16,
      number: 500,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 289,99'
    }
  ]

  const irandubaPlanes = [
    {
      id: 1,
      number: 100,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 99,99'
    },
    {
      id: 2,
      number: 200,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 129,99'
    },
    {
      id: 3,
      number: 300,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 139,99'
    },
    {
      id: 4,
      number: 500,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',

      price: 'R$ 159,99'
    },
    {
      id: 5,
      number: 300,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 119,99'
    },
    {
      id: 6,
      number: 300,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 249,99'
    },
    {
      id: 7,
      number: 400,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 129,99'
    },
    {
      id: 8,
      number: 400,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 259,99'
    },
    {
      id: 9,
      number: 500,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 139,99'
    },
    {
      id: 10,
      number: 500,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 269,99'
    },
    {
      id: 11,
      number: 300,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 139,99'
    },
    {
      id: 12,
      number: 300,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 269,99'
    },
    {
      id: 13,
      number: 400,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 149,99'
    },
    {
      id: 14,
      number: 400,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 279,99'
    },
    {
      id: 15,
      number: 500,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 159,99'
    },
    {
      id: 16,
      number: 500,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 289,99'
    }
  ]
  const itacoatiaraPlanes = [
    {
      id: 1,
      number: 100,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 99,99'
    },
    {
      id: 2,
      number: 200,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 129,99'
    },
    {
      id: 3,
      number: 300,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 139,99'
    },
    {
      id: 4,
      number: 500,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',

      price: 'R$ 159,99'
    },
    {
      id: 5,
      number: 300,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 119,99'
    },
    {
      id: 6,
      number: 300,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 249,99'
    },
    {
      id: 7,
      number: 400,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 129,99'
    },
    {
      id: 8,
      number: 400,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 259,99'
    },
    {
      id: 9,
      number: 500,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 139,99'
    },
    {
      id: 10,
      number: 500,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 269,99'
    },
    {
      id: 11,
      number: 300,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 139,99'
    },
    {
      id: 12,
      number: 300,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 269,99'
    },
    {
      id: 13,
      number: 400,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 149,99'
    },
    {
      id: 14,
      number: 400,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 279,99'
    },
    {
      id: 15,
      number: 500,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 159,99'
    },
    {
      id: 16,
      number: 500,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 289,99'
    }
  ]

  const parintinsPlanes = [
    {
      id: 1,
      number: 100,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 99,99'
    },
    {
      id: 2,
      number: 200,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 129,99'
    },
    {
      id: 3,
      number: 300,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 139,99'
    },
    {
      id: 4,
      number: 500,
      info: 'MEGA LTE',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 159,99'
    },
    {
      id: 5,
      number: 600,
      info: 'MEGA LTE',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 179,99'
    }
  ]

  const mauesPlanes = [
    {
      id: 1,
      number: 20,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 149,99'
    },
    {
      id: 2,
      number: 30,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 199,99'
    },
    {
      id: 3,
      number: 40,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 249,99'
    },
    {
      id: 4,
      number: 20,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 159,99'
    },
    {
      id: 5,
      number: 20,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 289,99'
    },
    {
      id: 6,
      number: 30,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 209,99'
    },
    {
      id: 7,
      number: 30,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 339,99'
    },
    {
      id: 8,
      number: 40,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 259,99'
    },
    {
      id: 9,
      number: 40,
      info: 'MEGA + TV NO APP',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 389,99'
    },
    {
      id: 10,
      number: 20,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 179,99'
    },
    {
      id: 11,
      number: 20,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 309,99'
    },
    {
      id: 12,
      number: 30,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 229,99'
    },
    {
      id: 13,
      number: 30,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 359,99'
    },
    {
      id: 14,
      number: 40,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'STAR',
      price: 'R$ 279,99'
    },
    {
      id: 15,
      number: 40,
      info: 'MEGA + TV NO APP + ROKU',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      info7: 'PLANO TV',
      info8: 'FULL',
      price: 'R$ 409,99'
    }
  ]
  const manapolisPlanes = [
    {
      id: 1,
      number: 50,
      info: 'MEGA',
      info1: 'WI-FI WOMP',
      info2: 'GRATUITO',
      info3: 'SUPORTE 24H',
      info4: 'GRATUITO',
      info5: 'INTERNET',
      info6: 'SEM FRANQUIA',
      price: 'R$ 199,99'
    }
  ]
  // helper: retorna o array de planos da cidade selecionada
     const planesByLocation = {
         manaus: manausPlanes,
         iranduba: irandubaPlanes,
         itacoatiara: itacoatiaraPlanes,
         parintins: parintinsPlanes,
         maues: mauesPlanes,
         manapolis: manapolisPlanes
       }
    
       const getPlanesByLocation = loc => {
         const key = normalizeKey(loc)
         return planesByLocation[key] ?? []
       }
    

// função para renderizar um card (reaproveita as classes CSS existentes)
const renderPlanCard = item => (
  <div className="Styled-item">
    <p className="Number">{item.number}</p>
    <p className="Number-info">{item.info}</p>
    {item.info1 && <p className="Info-up">{item.info1}</p>}
    {item.info2 && <p className="Info-bottom">{item.info2}</p>}
    {item.info3 && <p className="Info-up">{item.info3}</p>}
    {item.info4 && <p className="Info-bottom">{item.info4}</p>}
    {item.info5 && <p className="Info-up">{item.info5}</p>}
    {item.info6 && <p className="Info-bottom">{item.info6}</p>}
    {item.info7 && <p className="Info-up">{item.info7}</p>}
    {item.info8 && <p className="Info-bottom">{item.info8}</p>}
    <p className="Preço">{item.price}</p>
  </div>
)

  return (
    <div
      style={{
        background: 'linear-gradient(to right, #51235C, #1F0A57)'
      }}
    >
    <div>
      <div
        style={{
        color: '#1F0A57',
        fontSize: '25px',
        fontFamily: 'Barlow',
        fontWeight: 700,
        borderRadius: '20px',
        background: '#FDEB1A',
        paddingTop: '10px',
        paddingBottom: '20px',
        paddingLeft: '15px',
        paddingRight: '15px'
        }}
      >
        Informações Válidas apenas para {location}
      </div>

      </div>
      <div
        style={{
          marginTop: '40px',
          display: 'flex',
          alignItems: 'center', // Centralizar verticalmente
          justifyContent: 'center' // Centralizar horizontalmente (opcional)
        }}
      >
        <text
          style={{
            color: '#1F0A57',
            fontSize: '14px',
            fontFamily: 'Barlow',
            fontWeight: 700,
            borderRadius: '20px',
            background: '#FDEB1A',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: '15px',
            paddingRight: '15px'
          }}
        >
          {' '}
          Você não é de {location}? Escolha a sua localidade:
          <select
            onChange={e => handleLocationChange(e.target.value)}
            style={{
              color: '#FFF',
              fontSize: '12px',
              fontFamily: 'Barlow',
              fontWeight: 700,
              border: '0px',
              borderRadius: '8px',
              background: '#51235C',
              paddingTop: '8px',
              paddingBottom: '8px'
            }}
          >
            <option value="Manaus">Manaus</option>
            <option value="Iranduba">Iranduba</option>
            <option value="Itacoatiara">Itacoatiara</option>
            <option value="Parintins">Parintins</option>
            <option value="Maues">Maués</option>
            <option value="Manapolis">Manapolis</option>
          </select>
        </text>
      </div>
      {/* Planos - Carrossel (1 card por vez, centralizado) */}
      <div style={{ marginTop: '28px', display: 'flex', justifyContent: 'center' }}>
        <OneCardCarousel
          items={getPlanesByLocation(location)}
          renderItem={renderPlanCard}
        />
      </div>
      <div
        style={{
          marginTop: '40px'
        }}
      >
        
        <div>
          <text
            style={{
              color: '#1F0A57',
              fontSize: '25px',
              fontFamily: 'Barlow',
              fontWeight: 700,
              borderRadius: '20px',
              background: '#FDEB1A',
              paddingTop: '10px',
              paddingBottom: '20px',
              paddingLeft: '15px',
              paddingRight: '15px'
            }}
          >
            Womp Play válido para todo o Brasil
          </text>
        </div>
        <div
          style={{
            marginTop: '40px',
            display: 'flex',
            alignItems: 'center', // Centralizar verticalmente
            justifyContent: 'center' // Centralizar horizontalmente (opcional)
          }}
        >
          <text
            style={{
              color: '#1F0A57',
              fontSize: '14px',
              fontFamily: 'Barlow',
              fontWeight: 700,
              borderRadius: '20px',
              background: '#FDEB1A',
              paddingTop: '10px',
              paddingBottom: '10px',
              paddingLeft: '15px',
              paddingRight: '15px'
            }}
          >
            {' '}
            Quer saber mais sobre a womp play?{' '}
            <a
              href="https://www.wompplay.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Clique Aqui
            </a>
          </text>
        </div>
      </div>
            {/* Womp Play grid */}
            <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center' }}>
        <div className="plans-grid plans-grid--small" style={{ width: '100%', maxWidth: 800 }}>
          {[
            {
              id: 'wp-1',
              number: 120,
              info: 'CANAIS ABERTOS',
              info1: 'TELAS',
              info2: '2',
              info3: 'SUPORTE 24H',
              info4: 'GRATUITO',
              info5: 'OPERADORA',
              info6: 'TODO BRASIL',
              price: 'R$ 19,99'
            },
            {
              id: 'wp-2',
              number: 185,
              info: 'CANAIS ABERTOS + FECHADOS',
              info1: 'TELAS',
              info2: '3',
              info3: 'SUPORTE 24H',
              info4: 'GRATUITO',
              info5: 'OPERADORA',
              info6: 'TODO BRASIL',
              price: 'R$ 139,99'
            }
          ].map(item => (
            <div key={item.id} className="plan-grid-item">
              {renderPlanCard(item)}
            </div>
          ))}
        </div>
      </div>                            
    </div>
  )
}
